var map = {
	"./AlaiTaberna.webp": 2725,
	"./AndatzaTaberna.webp": 345,
	"./AngelCarrillo.webp": 7252,
	"./AvenidaTaberna.webp": 6158,
	"./BalerdiHarategia.webp": 6106,
	"./BarGenesis.webp": 7110,
	"./BarZumaburu.webp": 4791,
	"./BotikaGandariasUribe.webp": 2004,
	"./ElectricidadArregi.webp": 5510,
	"./Eroski.webp": 4602,
	"./GorkaYTxumi.webp": 8425,
	"./GureEtxea.webp": 7279,
	"./HiruAldeta.webp": 7624,
	"./Ilargi.webp": 6793,
	"./InakiTaberna.webp": 2600,
	"./Jalgi.webp": 2322,
	"./JoseAbogado.webp": 8069,
	"./LasarteTaberna.webp": 2262,
	"./Lavie.webp": 152,
	"./Madu.webp": 2050,
	"./OgiBerri.webp": 1768,
	"./OrekaAmara.webp": 4635,
	"./PatxiLarranaga.webp": 474,
	"./Santana.webp": 7837,
	"./TiburtzioArtizar.webp": 796,
	"./Xuhakan.webp": 3115
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3525;